import { atom } from 'jotai'
import { SetStateAction } from 'react'
import { ITokensState } from '../types'

const defaultState: ITokensState = null

// base atom with initial value
const _tokensAtom = atom<ITokensState>(defaultState)
// read-write derived atom
export const tokensAtom = atom(
	// getter
	(get) => get(_tokensAtom),

	// setter with custom logic
	(get, set, value: SetStateAction<ITokensState>) => {
		const currentValue = get(_tokensAtom)
		const nextValue =
			typeof value === 'function' ? value(currentValue) : value
		//console.log('tokensAtom: setter:: ', { currentValue, nextValue })
		// setter error handler
		if (!!nextValue && nextValue instanceof Object) {
			return set(_tokensAtom, nextValue)
		}
		throw new Error('tokensAtom: setter:: Incorrect value set')
	}
)
